import { HistoryModalTranslations } from "./models/history-modal-translaction-model";
import { SupportedLanguages } from "@/lang/lang-settings";
import { ptBR } from "./translactions/pt-BR";
import { enUS } from "./translactions/en-US";

export const historyModal: Record<SupportedLanguages, HistoryModalTranslations> = {
  'pt-BR': ptBR,
  'en-US': enUS,
};
